import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import AddBatchDisccount from "./AddBatchDisccount";
import { UseDiscountManagment } from "../UseDiscountManagment";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../../hooks/UseMyPC";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import DeleteRow from "../../../components/DeleteRow";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FilterSearch from "./FilterSearch";

export default function DirectDiscountList() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  var timer = null;
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { getBatchDiscount, deleteBatchDiscount } = UseDiscountManagment();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("IsActiveBD");
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [isActiveState, setIsActiveState] = useState(3);
  const [productRes, setProductRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getBatchDiscount(isActiveState, myPc, search, (products) => {
      setProductRes(products);
    });
  }, [myPc, isActiveState]);

  useEffect(() => {
    goToFirstPage();
  }, [search, isActiveState]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },

    {
      field: "productName",
      headerName: "نام محصول",
      width: 240,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "expireDay",
      width: 90,
      align: "center",
      headerName: "روز انقضا",
      headerAlign: "center",
    },
    {
      field: "shamsiExpire",
      width: 110,
      align: "center",
      headerName: "تاریخ انقضا",
      headerAlign: "center",
    },
    {
      field: "discountType",
      width: 90,
      align: "center",
      headerName: "نوع",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "limit",
      width: 80,
      align: "center",
      headerName: "تعداد",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "storeCount",
      width: 80,
      align: "center",
      headerName: "موجودی",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "discountPercent",
      headerName: "درصد تخفیف",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.discountPercent}
          </Typography>
        );
      },
    },
    {
      field: "isActiveBD",
      headerName: "وضعیت",
      width: 75,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isActiveBD ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 80,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="حذف">
            <IconButton
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: cellValues.row.productName,
                  productID: cellValues.row.id,
                });
              }}
            >
              <DeleteIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/discountmanagment",
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: "تخفیف بچ",
            url: "/discountmanagment/batchDiscount",
          },
        ],
      }}
    >
      <FilterSearch
        isActiveState={isActiveState}
        setIsActiveState={setIsActiveState}
      />
      <Box sx={{ height: "35rem", mb: 3 }}>
        {productRes ? (
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={productRes.pageCondition.pageCount}
            rows={productRes.products}
            paginationMode="server"
            page={productRes.pageCondition.page - 1}
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            sx={{
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "&  .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "&  .MuiDataGrid-cell:focus-within ": {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
              "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
              "& .MuiDataGrid-cell:hover": {
                color: "secondary.main",
              },
              "& .MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !important",
              },

              "& .green": {
                backgroundColor: "#56ff004f !important",
              },
            }}
            getRowClassName={(params) => {
              if (params.row.isActiveBD) {
                return "green";
              }
            }}
            componentsProps={{
              pagination: {
                scrollTo: myPc.scrollTo,
                isLtr: true,
                nofab: true,
                rowCount: productRes?.pageCondition.totalItemCount
                  ? productRes.pageCondition.totalItemCount
                  : "",
              },
            }}
            initialState={{
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc"
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        ) : (
          <ProgressCom></ProgressCom>
        )}
      </Box>
      <AddBatchDisccount
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول"}
        callback={() => {
          setProgress(true);
          let model = {
            productID: deleteState.productID,
          };
          deleteBatchDiscount(model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
